<template>
  <fragment>
    <mc-app-header title="Edit System Settings">
      <template #right>
        <div class="level-item">
          <b-button
            :loading="systemSettings.submitting"
            type="is-primary"
            form="editSettingsForm"
            native-type="submit"
            >Update</b-button
          >
        </div>
      </template>
    </mc-app-header>
    <mc-app-body>
      <div class="edit-setting section">
        <b-loading
          v-if="systemSettings.loadingSelected"
          active
          :is-full-page="false"
        />
        <mc-error-layout
          v-else-if="systemSettings.selectError"
          message="Failed to load system settings!"
          :retry-fn="() => load()"
        />
        <div v-else>
          <form
            id="editSettingsForm"
            class="edit-setting__form mc-container"
            @submit.prevent="updateSettingsHandler"
          >
            <b-field label="Initial Class">
              <mc-challenge-select
                v-model="systemSettings.selected.initialClass"
                class="classes__form__challenge-select"
              />
            </b-field>
            <b-field label="Initial Concept">
              <mc-concept-select
                v-model="systemSettings.selected.initialConcept"
                class="classes__form__concept-select"
              />
            </b-field>
            <div class="divider">App Version and Maintennance</div>
            <div class="columns">
              <div class="column">
                <b-field
                  class="edit-setting__form__switch"
                  label="Under Maintennance"
                >
                  <b-switch
                    v-model="systemSettings.selected.underMaintenance"
                    class="default"
                    disabled
                  >
                    {{
                      systemSettings.selected.underMaintenance ? 'Yes' : 'No'
                    }}
                  </b-switch>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Oldest Supported App Version">
                  <b-input
                    v-model="systemSettings.selected.oldestSupportedAppVersion"
                    icon="cellphone-android"
                    placeholder="Oldest Supported App Version"
                    type="text"
                  />
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field label="latest App Version (Android)">
                  <b-input
                    v-model="systemSettings.selected.latestAppVersionAndroid"
                    disabled
                    icon="android"
                    placeholder="latestAppVersion Android"
                    type="text"
                  />
                </b-field>
              </div>
              <div class="column">
                <b-field label="latest App Version (IOS)">
                  <b-input
                    v-model="systemSettings.selected.latestAppVersionIOS"
                    disabled
                    icon="apple"
                    placeholder="latestAppVersionIOS"
                    type="text"
                  />
                </b-field>
              </div>
            </div>
            <div class="divider">Mentor Info</div>
            <div class="columns">
              <div class="column">
                <b-field label="Mentor Name">
                  <b-input
                    v-model="systemSettings.selected.mentorName"
                    icon="account-outline"
                    placeholder="Mentor Name"
                    type="text"
                  />
                </b-field>
              </div>
              <div class="column">
                <mc-mobile-input
                  v-model="systemSettings.selected.mentorMobile"
                  label="Mentor Phone Number"
                ></mc-mobile-input>
              </div>
            </div>
            <div class="divider">Latest Blog</div>
            <b-field label="URL">
              <b-input
                v-model="systemSettings.selected.latestBlog.url"
                placeholder="Enter URL..."
                type="text"
              />
            </b-field>
            <b-field label="Title">
              <b-input
                v-model="systemSettings.selected.latestBlog.title"
                :required="systemSettings.selected.latestBlog.url"
                validation-message="Cannot be empty when blog url is present"
                placeholder="Enter Title..."
                type="text"
              />
            </b-field>
            <b-field label="Short Description">
              <b-input
                v-model="systemSettings.selected.latestBlog.description"
                :required="systemSettings.selected.latestBlog.url"
                validation-message="Cannot be empty when blog url is present"
                placeholder="Enter Short Description..."
                type="text"
              />
            </b-field>
          </form>
        </div>
      </div>
    </mc-app-body>
  </fragment>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['systemSettings'])
  },
  methods: {
    ...mapActions('systemSettings', ['load', 'updateSetting']),
    async updateSettingsHandler() {
      try {
        await this.updateSetting({
          ...this.systemSettings.selected
        });
        this.$buefy.toast.open({
          message: 'System Settings updated successfully',
          type: 'is-success'
        });
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to update System Settings!',
          type: 'is-danger'
        });
      }
    }
  },
  async created() {
    await this.load();
  }
};
</script>

<style lang="scss" scoped>
.media-content {
  white-space: normal;
}

.edit-setting {
  &__form {
    margin-bottom: 2rem;
    &__switch {
      display: flex;
      flex-direction: column;
    }
    .switch {
      padding: 0.3rem 0;
    }
  }
}
</style>
